// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

/* Start Login  */

.main-login{
    font-family: 'Inter', sans-serif;
    display: flex;
    height: 100vh;
    width: 100%;
}

.main-login .left{
    width: 50%;
    display: flex;
    flex-direction: column;
}

.main-login .left .sub-left{
    margin: 100px auto;
}


.main-login .left .head{
    display: flex;
    align-items: center;
}

.main-login .left .head h1{
    font-size: 19px;
    color:#065ad8;
    font-weight: bold;
    margin-left: 8px;
}

.main-login .left .head .image img{
    width: 70px;
}

.main-login .left  h2 {
margin-top: 14px;
font-size: 21px;
margin-bottom: 10px;
margin-left: 4px;
font-weight: bold;
}

.main-login .left .sub-title{
    color:#686d78;
    font-weight: 400;
    font-size: 12px;
}

.main-login .left .login-form{
    margin-top: 20px;
}

.main-login .left .login-form .input-field{
    /* #9b9ea6 */
    width: 300px;
    max-width: 100%;
    display: flex;
    align-items: center;
    background-color: #fafbfe;
    padding: 11px 12px;
    border: 1px solid #EEE;
    border-radius: 8px;
    margin: 5px 0px;
    transition: var(--main-transition);
}

.main-login .left .login-form .input-field-active{
    border: 1px solid var(--main-color);
}

.main-login .left .login-form .unvalid-input{
    border-color:#dc3545 ;
}

.main-login .left .login-form .input-field input{
    background-color: transparent;
    color: gray;
    border: none;
    margin:0px 10px;
    width: calc(100% - 20px);

}

.main-login .left .login-form .input-field svg{
    width: 20px;
}

.main-login .left .login-form .input-field input:focus{
    outline: none;

}

.main-login .left .login-form .input-pass img{
    width: 20px;
}

.main-login .left .login-form .input-pass{
    justify-content: space-between;
    
}

.main-login .left .login-form .input-pass input{
    width: calc(100% - 20px);
}



.main-login .left .login-form .input-pass .right-input{
    width: 30px;
}

.main-login .left .login-form .input-pass .left{
    display: flex;
    width: calc(100% - 20px);
    align-items: center;
    flex-direction: row;
}

.main-login .left .login-form .forget-password{
    color: var(--main-color);
    padding: 5px 0px;
    text-decoration: none;
    font-size: 13px;
}

.main-login .right{
    width: 50%;
    background-color: var(--main-color);
    position: relative;
    
}

.main-login .right .logo-main {
    width: 600px;
    max-width: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50% , -50%);
    z-index: 100;
}

.main-login .left .login-form .btn-login {
    background-color: var(--main-color);
    padding: 12px 22px;
    width: 100%;
    border-radius: 8px;
    border: none;
    color: white;
    font-weight: bold;
    margin-top: 20px;
    transition: var(--main-transition);
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
}

.main-login .left .login-form .btn-login:hover{
    background-color: #3882f1;
}

.main-login .valid-message{
    visibility: hidden;
    opacity: 0;
    transition: var(--main-transition);
    color: #dc3545;
}

.main-login .valid-active-message{
visibility: visible;
opacity: 1;
}

.main-login .cricle-lodding{
    width: 18px;
    height: 18px;
    border-radius: 50%;
    border: 3px solid white;
    border-top-color: transparent;
}


/* .main-login .right .rotate-roll{
    width: 200px;
    position: absolute;
    background-color: var(--main-color);
    height: 100%;
    left: -100px;
    transform: skewX(15deg);
} */

@media(max-width:550px){
    .main-login .right{
        display: none !important;
    }
    .main-login .left{
        width: 100%;
    }
}

@media(max-width :880px){
    .main-login .right{
        display: none !important;
    }
    .main-login .left{
        width: 100%;
    }
}


/* End Login  */`, "",{"version":3,"sources":["webpack://./src/Pages/Login/login.css"],"names":[],"mappings":";;AAEA,iBAAiB;;AAEjB;IACI,gCAAgC;IAChC,aAAa;IACb,aAAa;IACb,WAAW;AACf;;AAEA;IACI,UAAU;IACV,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;AACtB;;;AAGA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;AACA,gBAAgB;AAChB,eAAe;AACf,mBAAmB;AACnB,gBAAgB;AAChB,iBAAiB;AACjB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,kCAAkC;AACtC;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,6BAA6B;IAC7B,WAAW;IACX,YAAY;IACZ,eAAe;IACf,wBAAwB;;AAE5B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;;AAEjB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,8BAA8B;;AAElC;;AAEA;IACI,wBAAwB;AAC5B;;;;AAIA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,wBAAwB;IACxB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;IACxB,gBAAgB;IAChB,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,mCAAmC;IACnC,kBAAkB;;AAEtB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,iCAAiC;IACjC,YAAY;AAChB;;AAEA;IACI,mCAAmC;IACnC,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,kCAAkC;IAClC,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,kCAAkC;IAClC,cAAc;AAClB;;AAEA;AACA,mBAAmB;AACnB,UAAU;AACV;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,6BAA6B;AACjC;;;AAGA;;;;;;;GAOG;;AAEH;IACI;QACI,wBAAwB;IAC5B;IACA;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;IACA;QACI,WAAW;IACf;AACJ;;;AAGA,eAAe","sourcesContent":["\n\n/* Start Login  */\n\n.main-login{\n    font-family: 'Inter', sans-serif;\n    display: flex;\n    height: 100vh;\n    width: 100%;\n}\n\n.main-login .left{\n    width: 50%;\n    display: flex;\n    flex-direction: column;\n}\n\n.main-login .left .sub-left{\n    margin: 100px auto;\n}\n\n\n.main-login .left .head{\n    display: flex;\n    align-items: center;\n}\n\n.main-login .left .head h1{\n    font-size: 19px;\n    color:#065ad8;\n    font-weight: bold;\n    margin-left: 8px;\n}\n\n.main-login .left .head .image img{\n    width: 70px;\n}\n\n.main-login .left  h2 {\nmargin-top: 14px;\nfont-size: 21px;\nmargin-bottom: 10px;\nmargin-left: 4px;\nfont-weight: bold;\n}\n\n.main-login .left .sub-title{\n    color:#686d78;\n    font-weight: 400;\n    font-size: 12px;\n}\n\n.main-login .left .login-form{\n    margin-top: 20px;\n}\n\n.main-login .left .login-form .input-field{\n    /* #9b9ea6 */\n    width: 300px;\n    max-width: 100%;\n    display: flex;\n    align-items: center;\n    background-color: #fafbfe;\n    padding: 11px 12px;\n    border: 1px solid #EEE;\n    border-radius: 8px;\n    margin: 5px 0px;\n    transition: var(--main-transition);\n}\n\n.main-login .left .login-form .input-field-active{\n    border: 1px solid var(--main-color);\n}\n\n.main-login .left .login-form .unvalid-input{\n    border-color:#dc3545 ;\n}\n\n.main-login .left .login-form .input-field input{\n    background-color: transparent;\n    color: gray;\n    border: none;\n    margin:0px 10px;\n    width: calc(100% - 20px);\n\n}\n\n.main-login .left .login-form .input-field svg{\n    width: 20px;\n}\n\n.main-login .left .login-form .input-field input:focus{\n    outline: none;\n\n}\n\n.main-login .left .login-form .input-pass img{\n    width: 20px;\n}\n\n.main-login .left .login-form .input-pass{\n    justify-content: space-between;\n    \n}\n\n.main-login .left .login-form .input-pass input{\n    width: calc(100% - 20px);\n}\n\n\n\n.main-login .left .login-form .input-pass .right-input{\n    width: 30px;\n}\n\n.main-login .left .login-form .input-pass .left{\n    display: flex;\n    width: calc(100% - 20px);\n    align-items: center;\n    flex-direction: row;\n}\n\n.main-login .left .login-form .forget-password{\n    color: var(--main-color);\n    padding: 5px 0px;\n    text-decoration: none;\n    font-size: 13px;\n}\n\n.main-login .right{\n    width: 50%;\n    background-color: var(--main-color);\n    position: relative;\n    \n}\n\n.main-login .right .logo-main {\n    width: 600px;\n    max-width: 100%;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50% , -50%);\n    z-index: 100;\n}\n\n.main-login .left .login-form .btn-login {\n    background-color: var(--main-color);\n    padding: 12px 22px;\n    width: 100%;\n    border-radius: 8px;\n    border: none;\n    color: white;\n    font-weight: bold;\n    margin-top: 20px;\n    transition: var(--main-transition);\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.main-login .left .login-form .btn-login:hover{\n    background-color: #3882f1;\n}\n\n.main-login .valid-message{\n    visibility: hidden;\n    opacity: 0;\n    transition: var(--main-transition);\n    color: #dc3545;\n}\n\n.main-login .valid-active-message{\nvisibility: visible;\nopacity: 1;\n}\n\n.main-login .cricle-lodding{\n    width: 18px;\n    height: 18px;\n    border-radius: 50%;\n    border: 3px solid white;\n    border-top-color: transparent;\n}\n\n\n/* .main-login .right .rotate-roll{\n    width: 200px;\n    position: absolute;\n    background-color: var(--main-color);\n    height: 100%;\n    left: -100px;\n    transform: skewX(15deg);\n} */\n\n@media(max-width:550px){\n    .main-login .right{\n        display: none !important;\n    }\n    .main-login .left{\n        width: 100%;\n    }\n}\n\n@media(max-width :880px){\n    .main-login .right{\n        display: none !important;\n    }\n    .main-login .left{\n        width: 100%;\n    }\n}\n\n\n/* End Login  */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
